import { env } from './env';

/** Registra el service worker solo en la web (no en el APK) y recarga una vez cuando hay versión nueva. */
export function registerServiceWorker() {
  if (env.isNative || !('serviceWorker' in navigator) || import.meta.env.DEV) return;
  const hadController = !!navigator.serviceWorker.controller;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Solo si ya había una versión anterior controlando la página (no en la primera visita).
    if (!hadController || reloaded) return;
    reloaded = true;
    window.location.reload();
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { type: 'module' })
      .then((reg) => {
        // Buscar versión nueva al volver a la app (los teléfonos dejan la pestaña abierta días).
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') void reg.update().catch(() => undefined);
        });
      })
      .catch(() => {
        /* sin soporte o bloqueado: la app funciona igual */
      });
  });
}

/**
 * Tras publicar una versión nueva, una pestaña vieja puede pedir archivos que ya no existen
 * ("Importing a module script failed"). Se recarga una sola vez para tomar la versión actual.
 */
export function reloadOnStaleChunk(): boolean {
  const KEY = 'tcrd:chunk-reload';
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return false; // ya se intentó: evitar bucles
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sin sessionStorage: recargar igual */
  }
  window.location.reload();
  return true;
}

export const isChunkLoadError = (e: unknown) =>
  /module script|dynamically imported module|Failed to fetch dynamically|error loading dynamically|Importing a module/i.test(String((e as Error)?.message ?? e));
